// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../node_modules/ui-connect/styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings .settings-container {
    max-width: 650px;
}
.settings label.label-90 {
    width: 90px;
    display: inline-block;
    float: left;
}
/*ADDING CSS TO MAKE THE LABEL-90 CHECKBOXES CLICKABLE*/
.settings .checkbox {
    position: relative;
    z-index: 1;
}
.settings table td.centered {
    text-align: center;
}
/*  ======================
      Unselected Label
      ======================  */
.settings .radio-buttons label {
    display: inline-block;
    position: relative;
    padding: 0;
    vertical-align: top;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}
.settings .radio-checkbox input[type='checkbox'], .settings .radio-buttons input[type='radio'] {
    opacity: 0;
    -webkit-appearance: none;
    display: inline-block;
    vertical-align: middle;
    z-index: 100;
}
/*BORDER OF CHECK BOX*/
/*this is to line up the radio buttons with the other form elements*/
.settings .settings-container .controls-row [class*='span']:first-child {
    margin-left: 0;
}
.settings .radio-buttons label::before {
    content: '';
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
}
.settings .checkbox-buttons input[type='checkbox'] + label, .settings .radio-buttons input[type='radio'] + label {
    width: calc(100% - 20px);
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
    padding: 10px;
    margin-top: -20px;
    text-align: center;
    border-radius: 4px;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["white"]};
    border: 1px solid #ccc;
    box-shadow: 0 2px 0 #eee;
}
.settings .checkbox-buttons input[type='checkbox']:checked + label, .settings .radio-buttons input[type='radio']:checked + label {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["green_light_1"]};
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["green_dark_3"]};
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}
/*this helps the "display" text line up with the on/off switch*/
.settings label.inline-block {
    display: inline-block;
    min-width: 50px;
    margin-top: 5px;
}
.settings .profile-photo img {
    background-size: 200px 200px;
    border-radius: 7px;
}
/*this makes the firts checkbox in a column line up properly*/
.settings .controls-row [class*='span']:first-child {
    margin-left: 2.564102564102564%;
}
/* No greater than 900px, no less than 400px */
@media (max-width: 1199px) and (min-width: 980px) {
    .settings .controls-row [class*='span']:first-child {
        margin-left: 1.4%;
    }
}
.settings .personal-info .controls-row [class*='span']:first-child {
    margin-left: 0;
}
/*This is for the save /cancel buttons on the inline-edit fields*/
.settings .controls-row .inline-edit button {
    margin-top: 4px;
    margin-left: 3px;
}
/* Notification Settings Group Toggle Component */
.toggle-group .control-group, .toggle-group .toggle-parent h6 {
    margin-bottom: 0;
}
.toggle-group .toggle-child h6, .toggle-group .toggle-child > label {
    margin-left: 20px;
}
.toggle-group .toggle-child > label {
    clear: left;
}
.toggle-group .control-group > label {
    float: left;
}
.toggle-group .btn-switch-container {
    float: right;
}
/* Disabled Styles */
.toggle-group .toggle-child.disabled input {
    display: none;
}
.toggle-group .toggle-child.disabled label {
    cursor: default;
}
.toggle-group .toggle-child.disabled .checkbox {
    padding-left: 0;
}
.hydration-info-label {
    font-size: 12px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textMedium"]};
    max-width: 500px;
}
.hydration-settings-heading {
    display: flex;
}
.hydration-info-containers h6 {
    font-weight: 300;
}
.menstrual-cycle-tracking-settings-container .menstrual-cycle-tracking-sub-item {
    padding-left: 40px;
}
.menstrual-cycle-tracking-sub-item .content-no-wrap {
    white-space: nowrap;
}
.fertile-window-prediction-checkbox[disabled] + label, .period-prediction-checkbox[disabled] + label {
    transition: width 0.5s;
    opacity: 0.3;
}
.menstrual-cycle-tracking-settings-container .settings-container label {
    word-break: break-all;
}
.menstrual-cycle-tracking-settings-container .settings-container label:nth-child(2n + 3) {
    clear: both;
}
.disabled-label {
    opacity: 0.5;
}
.to-lowercase {
    text-transform: lowercase;
}
.predictions-information {
    font-size: 12px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textMedium"]};
}
@media (max-width: 767px) {
    .settings .input-large {
        width: 210px;
    }
    .settings .input-prepend input.input-xsmall, .input-append input.input-xsmall {
        width: 18px;
    }
    .settings .input-prepend input.input-mini, .input-append input.input-mini {
        width: 30px;
    }
    .settings .input-prepend input.input-small, .input-append input.input-small {
        width: 60px;
    }
}
@media (max-width: 480px) {
    .hydration-info-containers {
        margin-left: 0;
    }
}
.settings-container .flex-table {
    display: flex;
    flex-flow: column nowrap;
    border-top: 1px solid #eee;
    border-width: 1px 0;
    margin-bottom: -1px;
    margin-top: 5px;
}
.settings-container .flex-row {
    display: flex;
    margin-left: 0px;
}
.settings-container .flex-row.top-m {
    margin-top: 20px;
}
.settings-container .flex-row.app-header {
    margin-top: 30px;
    margin-bottom: -20px;
}
.settings-container .flex-col {
    flex-basis: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
}
.settings-container .flex-col.right-align {
    text-align: right;
    padding-right: 10px;
    padding-left: 30px;
    flex: 1;
}
.settings-container .flex-col.left-align {
    text-align: left;
    padding-left: 10px;
    flex: 2;
}
.settings-container .flex-col.center-align {
    display: flex;
    justify-content: center;
}
.option-spacing-right {
    margin-right: 30px;
}
.privacy-action-button {
    font-size: 14px;
    text-align: left;
}
.notificationItem {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical !important;
    /* autoprefixer: off */
}
`, "",{"version":3,"sources":["webpack://./src/styles/settings.page.module.css"],"names":[],"mappings":"AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;AACf;AACA,uDAAuD;AACvD;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;;+BAE+B;AAC/B;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,oBAAoB;AACxB;AACA;IAEI,UAAU;IACV,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;AAChB;AACA,sBAAsB;AACtB,oEAAoE;AACpE;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,gCAAgC;IAChC,wBAAwB;AAC5B;AACA;IAEI,wBAAwB;IACxB,mDAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,8DAAuB;IACvB,sBAAsB;IACtB,wBAAwB;AAC5B;AACA;IAEI,mDAAe;IACf,wDAAyB;IACzB,8DAA8B;IAC9B,4BAA4B;IAC5B,oBAAoB;AACxB;AACA,+DAA+D;AAC/D;IACI,qBAAqB;IACrB,eAAe;IACf,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;AACA,6DAA6D;AAC7D;IACI,+BAA+B;AACnC;AACA,8CAA8C;AAC9C;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,cAAc;AAClB;AACA,iEAAiE;AACjE;IACI,eAAe;IACf,gBAAgB;AACpB;AACA,iDAAiD;AACjD;IAEI,gBAAgB;AACpB;AACA;IAEI,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA,oBAAoB;AACpB;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,mDAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IAEI,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,mDAAiB;AACrB;AACA;IACI;QACI,YAAY;IAChB;IACA;QAEI,WAAW;IACf;IACA;QAEI,WAAW;IACf;IACA;QAEI,WAAW;IACf;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,aAAa;IACb,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;AACX;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;AACX;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,uCAAuC;IACvC,sBAAsB;AAC1B","sourcesContent":["@value ( black, white, textMedium, textDark, green_light_1, green_dark_3 ) from 'ui-connect/styles/colors.module.css';\n:global .settings .settings-container {\n    max-width: 650px;\n}\n:global .settings label.label-90 {\n    width: 90px;\n    display: inline-block;\n    float: left;\n}\n/*ADDING CSS TO MAKE THE LABEL-90 CHECKBOXES CLICKABLE*/\n:global .settings .checkbox {\n    position: relative;\n    z-index: 1;\n}\n:global .settings table td.centered {\n    text-align: center;\n}\n/*  ======================\n      Unselected Label\n      ======================  */\n:global .settings .radio-buttons label {\n    display: inline-block;\n    position: relative;\n    padding: 0;\n    vertical-align: top;\n    cursor: pointer;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n}\n:global .settings .radio-checkbox input[type='checkbox'],\n:global .settings .radio-buttons input[type='radio'] {\n    opacity: 0;\n    -webkit-appearance: none;\n    display: inline-block;\n    vertical-align: middle;\n    z-index: 100;\n}\n/*BORDER OF CHECK BOX*/\n/*this is to line up the radio buttons with the other form elements*/\n:global .settings .settings-container .controls-row [class*='span']:first-child {\n    margin-left: 0;\n}\n:global .settings .radio-buttons label::before {\n    content: '';\n    -webkit-transition: opacity 0.3s;\n    transition: opacity 0.3s;\n}\n:global .settings .checkbox-buttons input[type='checkbox'] + label,\n:global .settings .radio-buttons input[type='radio'] + label {\n    width: calc(100% - 20px);\n    color: textDark;\n    padding: 10px;\n    margin-top: -20px;\n    text-align: center;\n    border-radius: 4px;\n    background-color: white;\n    border: 1px solid #ccc;\n    box-shadow: 0 2px 0 #eee;\n}\n:global .settings .checkbox-buttons input[type='checkbox']:checked + label,\n:global .settings .radio-buttons input[type='radio']:checked + label {\n    color: textDark;\n    background: green_light_1;\n    border: 1px solid green_dark_3;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n}\n/*this helps the \"display\" text line up with the on/off switch*/\n:global .settings label.inline-block {\n    display: inline-block;\n    min-width: 50px;\n    margin-top: 5px;\n}\n:global .settings .profile-photo img {\n    background-size: 200px 200px;\n    border-radius: 7px;\n}\n/*this makes the firts checkbox in a column line up properly*/\n:global .settings .controls-row [class*='span']:first-child {\n    margin-left: 2.564102564102564%;\n}\n/* No greater than 900px, no less than 400px */\n@media (max-width: 1199px) and (min-width: 980px) {\n    :global .settings .controls-row [class*='span']:first-child {\n        margin-left: 1.4%;\n    }\n}\n:global .settings .personal-info .controls-row [class*='span']:first-child {\n    margin-left: 0;\n}\n/*This is for the save /cancel buttons on the inline-edit fields*/\n:global .settings .controls-row .inline-edit button {\n    margin-top: 4px;\n    margin-left: 3px;\n}\n/* Notification Settings Group Toggle Component */\n:global .toggle-group .control-group,\n:global .toggle-group .toggle-parent h6 {\n    margin-bottom: 0;\n}\n:global .toggle-group .toggle-child h6,\n:global .toggle-group .toggle-child > label {\n    margin-left: 20px;\n}\n:global .toggle-group .toggle-child > label {\n    clear: left;\n}\n:global .toggle-group .control-group > label {\n    float: left;\n}\n:global .toggle-group .btn-switch-container {\n    float: right;\n}\n/* Disabled Styles */\n:global .toggle-group .toggle-child.disabled input {\n    display: none;\n}\n:global .toggle-group .toggle-child.disabled label {\n    cursor: default;\n}\n:global .toggle-group .toggle-child.disabled .checkbox {\n    padding-left: 0;\n}\n:global .hydration-info-label {\n    font-size: 12px;\n    color: textMedium;\n    max-width: 500px;\n}\n:global .hydration-settings-heading {\n    display: flex;\n}\n:global .hydration-info-containers h6 {\n    font-weight: 300;\n}\n:global .menstrual-cycle-tracking-settings-container .menstrual-cycle-tracking-sub-item {\n    padding-left: 40px;\n}\n:global .menstrual-cycle-tracking-sub-item .content-no-wrap {\n    white-space: nowrap;\n}\n:global .fertile-window-prediction-checkbox[disabled] + label,\n:global .period-prediction-checkbox[disabled] + label {\n    transition: width 0.5s;\n    opacity: 0.3;\n}\n:global .menstrual-cycle-tracking-settings-container .settings-container label {\n    word-break: break-all;\n}\n:global .menstrual-cycle-tracking-settings-container .settings-container label:nth-child(2n + 3) {\n    clear: both;\n}\n:global .disabled-label {\n    opacity: 0.5;\n}\n:global .to-lowercase {\n    text-transform: lowercase;\n}\n:global .predictions-information {\n    font-size: 12px;\n    color: textMedium;\n}\n@media (max-width: 767px) {\n    :global .settings .input-large {\n        width: 210px;\n    }\n    :global .settings .input-prepend input.input-xsmall,\n    :global .input-append input.input-xsmall {\n        width: 18px;\n    }\n    :global .settings .input-prepend input.input-mini,\n    :global .input-append input.input-mini {\n        width: 30px;\n    }\n    :global .settings .input-prepend input.input-small,\n    :global .input-append input.input-small {\n        width: 60px;\n    }\n}\n@media (max-width: 480px) {\n    :global .hydration-info-containers {\n        margin-left: 0;\n    }\n}\n:global .settings-container .flex-table {\n    display: flex;\n    flex-flow: column nowrap;\n    border-top: 1px solid #eee;\n    border-width: 1px 0;\n    margin-bottom: -1px;\n    margin-top: 5px;\n}\n:global .settings-container .flex-row {\n    display: flex;\n    margin-left: 0px;\n}\n:global .settings-container .flex-row.top-m {\n    margin-top: 20px;\n}\n:global .settings-container .flex-row.app-header {\n    margin-top: 30px;\n    margin-bottom: -20px;\n}\n:global .settings-container .flex-col {\n    flex-basis: 100%;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n:global .settings-container .flex-col.right-align {\n    text-align: right;\n    padding-right: 10px;\n    padding-left: 30px;\n    flex: 1;\n}\n:global .settings-container .flex-col.left-align {\n    text-align: left;\n    padding-left: 10px;\n    flex: 2;\n}\n:global .settings-container .flex-col.center-align {\n    display: flex;\n    justify-content: center;\n}\n:global .option-spacing-right {\n    margin-right: 30px;\n}\n:global .privacy-action-button {\n    font-size: 14px;\n    text-align: left;\n}\n:global .notificationItem {\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    -webkit-box-orient: vertical !important;\n    /* autoprefixer: off */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"black": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["black"]}`,
	"white": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["white"]}`,
	"textMedium": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textMedium"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"green_light_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["green_light_1"]}`,
	"green_dark_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["green_dark_3"]}`,
	"settings": `settings`,
	"settings-container": `settings-container`,
	"label-90": `label-90`,
	"checkbox": `checkbox`,
	"centered": `centered`,
	"radio-buttons": `radio-buttons`,
	"radio-checkbox": `radio-checkbox`,
	"controls-row": `controls-row`,
	"checkbox-buttons": `checkbox-buttons`,
	"inline-block": `inline-block`,
	"profile-photo": `profile-photo`,
	"personal-info": `personal-info`,
	"inline-edit": `inline-edit`,
	"toggle-group": `toggle-group`,
	"control-group": `control-group`,
	"toggle-parent": `toggle-parent`,
	"toggle-child": `toggle-child`,
	"btn-switch-container": `btn-switch-container`,
	"disabled": `disabled`,
	"hydration-info-label": `hydration-info-label`,
	"hydration-settings-heading": `hydration-settings-heading`,
	"hydration-info-containers": `hydration-info-containers`,
	"menstrual-cycle-tracking-settings-container": `menstrual-cycle-tracking-settings-container`,
	"menstrual-cycle-tracking-sub-item": `menstrual-cycle-tracking-sub-item`,
	"content-no-wrap": `content-no-wrap`,
	"fertile-window-prediction-checkbox": `fertile-window-prediction-checkbox`,
	"period-prediction-checkbox": `period-prediction-checkbox`,
	"disabled-label": `disabled-label`,
	"to-lowercase": `to-lowercase`,
	"predictions-information": `predictions-information`,
	"input-large": `input-large`,
	"input-prepend": `input-prepend`,
	"input-xsmall": `input-xsmall`,
	"input-append": `input-append`,
	"input-mini": `input-mini`,
	"input-small": `input-small`,
	"flex-table": `flex-table`,
	"flex-row": `flex-row`,
	"top-m": `top-m`,
	"app-header": `app-header`,
	"flex-col": `flex-col`,
	"right-align": `right-align`,
	"left-align": `left-align`,
	"center-align": `center-align`,
	"option-spacing-right": `option-spacing-right`,
	"privacy-action-button": `privacy-action-button`,
	"notificationItem": `notificationItem`
};
export default ___CSS_LOADER_EXPORT___;
